import React, { useState } from "react";
import Slider from "react-slick";
import SectionHeading2 from "../SectionHeading/SectionHeading2";
import { Icon } from "@iconify/react";

const ServiceSlider = ({ data, varient }) => {
  const { sectionHeadingData, services } = data;

  const [playing, setPlaying] = useState(null);

  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <div
      {...props}
      className={
        "slick-arrow-left slick-arrow" +
        (currentSlide === 0 ? " slick-disabled" : "")
      }
      aria-hidden="true"
      aria-disabled={currentSlide === 0 ? true : false}
    >
      <Icon icon="fa-solid:angle-left" />
    </div>
  );

  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <div
      {...props}
      className={
        "slick-arrow-right slick-arrow" +
        (currentSlide === slideCount - 1 ? " slick-disabled" : "")
      }
      aria-hidden="true"
      aria-disabled={currentSlide === slideCount - 1 ? true : false}
    >
      <Icon icon="fa-solid:angle-right" />
    </div>
  );

  const settings = {
    dots: false,
    infinite: true,
    loop: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          dots: true,
        },
      },
    ],
  };

  return (
    <section
      id="service"
      className={`${varient === "st-type1" ? "" : "st-bluis-bg"}`}
    >
      <div className="st-height-b120 st-height-lg-b80" />
      <SectionHeading2 data={sectionHeadingData} />
      <div className="container">
        <Slider {...settings} className="st-slider-style3">
          {services.map((elements, index) => (
            <div key={index} className="">
              {elements.videoSrc.includes("youtube.com") ? (
                <div
                  className="video-container"
                  style={{ position: "relative" }}
                >
                  {playing !== index && (
                    <>
                      <img
                        src={elements.poster}
                        alt={elements.title}
                        style={{
                          width: "100%",
                          height: "300px",
                          objectFit: "cover",
                          cursor: "pointer",
                        }}
                        onClick={() => setPlaying(index)}
                      />
                      <div
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          color: "white",
                          fontSize: "48px",
                          cursor: "pointer",
                        }}
                        onClick={() => setPlaying(index)}
                      >
                        <svg
                          width="50"
                          height="50"
                          viewBox="0 0 277 277"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="138.5"
                            cy="138.5"
                            r="138.5"
                            fill="#925A27"
                          />
                          <path
                            d="M194.857 135.032L109.607 92.4069C108.406 91.8102 106.984 91.8721 105.841 92.5774C104.698 93.2865 104 94.5304 104 95.8749V181.125C104 182.47 104.698 183.713 105.841 184.423C106.461 184.806 107.166 185 107.875 185C108.468 185 109.061 184.864 109.607 184.593L194.857 141.968C196.171 141.309 197 139.969 197 138.5C197 137.031 196.171 135.691 194.857 135.032Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </>
                  )}
                  {playing === index && (
                    <iframe
                      width="100%"
                      height="300"
                      src={`${elements.videoSrc}?autoplay=1`}
                      title={elements.title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                    ></iframe>
                  )}
                </div>
              ) : (
                <video
                  controls
                  className="videocontrol"
                  poster={elements.poster}
                >
                  <source src={elements.videoSrc} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              )}
              <div className="st-height-b10 st-height-lg-b10" />
              <h6 className="">{elements.title}</h6>
              <p className="text-gray-700">{elements.description}</p>
            </div>
          ))}
        </Slider>
      </div>
      <div className="st-height-b120 st-height-lg-b80" />
    </section>
  );
};

export default ServiceSlider;
